var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQueries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E3D49",
    d: "M8 0C12.418 0 16 1.79 16 4C16 6.21 12.418 8 8 8C3.582 8 0 6.21 0 4C0 1.79 3.582 0 8 0ZM16 6V9C16 11.21 12.418 13 8 13C3.582 13 0 11.21 0 9V6C0 8.21 3.582 10 8 10C12.418 10 16 8.21 16 6ZM16 11V14C16 16.21 12.418 18 8 18C3.582 18 0 16.21 0 14V11C0 13.21 3.582 15 8 15C12.418 15 16 13.21 16 11Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueries);
export default __webpack_public_path__ + "static/media/queries.f187ec074082fdda6e9e6dc1b6412010.svg";
export { ForwardRef as ReactComponent };